import { ToothProblemModel } from "./tooth-problem.model"

export class PetDentalModel {
    pet_no: number
    pet_dental: string
    occlusion: string
    occlusion_name: string
    abnormality: string
    abnormality_name: string
    perio: string
    perio_name: string
    calc: string
    calc_name: string
    plaque: string
    plaque_name: string
    bleed: string
    bleed_name: string
    username: string
    note_type: string
    note: string
    tooth_problem: ToothProblemModel[]

    constructor(
        pet_no: number,
        pet_dental: string,
        occlusion: string,
        occlusion_name: string,
        abnormality: string,
        abnormality_name: string,
        perio: string,
        perio_name: string,
        calc: string,
        calc_name: string,
        plaque: string,
        plaque_name: string,
        bleed: string,
        bleed_name: string,
        username: string,
        note_type: string,
        note: string,
        tooth_problem: ToothProblemModel[]
    ) {
        this.pet_no = pet_no
        this.pet_dental = pet_dental
        this.occlusion = occlusion
        this.occlusion_name = occlusion_name
        this.abnormality = abnormality
        this.abnormality_name = abnormality_name
        this.perio = perio
        this.perio_name = perio_name
        this.calc = calc
        this.calc_name = calc_name
        this.plaque = plaque
        this.plaque_name = plaque_name
        this.bleed = bleed
        this.bleed_name = bleed_name
        this.username = username
        this.note_type = note_type
        this.note = note
        this.tooth_problem = tooth_problem
    }
}